export const CONFIRMATION_REQUIRED_INPUT_TEST_ID =
  'confirmation-required-input';
